import {useEffect, useState} from "react";
import {PartnerApi} from "../api/partner.api";
import {NavLink, useParams} from "react-router";
import {useAuthStore} from "../store/auth.store";
import {useBreadcrumbsStore} from "../store/breadcrumbs.store";
import { useTranslation } from "../hooks/useTranslation";

function ChangePassword(props) {
    const { t } = useTranslation();
    const { email, code } = useParams();
    const [password, setPassword] = useState('');
    const [recoveryCode, setRecoveryCode] = useState('');
    const [error, setError] = useState(null);
    const [step2, setStep2] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
    const setPagename = useBreadcrumbsStore((state) => state.setPagename);
    useEffect(()=>{
        setPagename(t("auth.changePassword"));
        setBreadcrumbs([]);

        if (email && code) {
            setRecoveryCode(code);
            setStep2(true);
        }
    },[]);

    const user = useAuthStore((state) => state.user);

    if (!user) {
        return <></>;
    }



    const handleSubmit = (e) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);

        if (step2) {
            const result = PartnerApi.passwordRecoveryCode(
                {
                    username: user.email, data: {
                        password,
                        recovery_code: recoveryCode,
                    },
                },
            );

            result.then((result) => {
                if ("error" in result) {
                    setError(result.error);
                    return;
                }
                setStep2(null);
                window.location.href = "/";
            }).finally(() => {
                setIsLoading(false);
            });
        } else {
            const result = PartnerApi.passwordRecovery(user.email);

            result.then((result) => {
                if ("code" in result && result.code == 401) {
                    setError(t("auth.userNotFound"));
                    return;
                }
                if ("error" in result) {
                    setError(result.error);
                    return;
                }
                if ("message" in result) {
                    setStep2(result.message);
                    return;
                }

                setStep2(true);
            }).finally(() => {
                setIsLoading(false);
            });
        }
    };
    return (
        <>
            <div className="d-flex flex-column flex-lg-row flex-column-fluid">
                <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
                    <div className="d-flex flex-center flex-column flex-lg-row-fluid">
                        <div className="w-lg-500px p-10">
                            <form onSubmit={handleSubmit} className="form w-100" noValidate="novalidate"
                                  id="kt_sign_in_form"
                                  data-kt-redirect-url="index.html" action="#">
                                {error != null && (
                                    <p className="text-danger">{error}</p>
                                )}
                                {step2 && (
                                    <>
                                        <div className="fv-row mb-8">
                                            <input placeholder={t("auth.verificationCode")} name="code2fa" autoComplete="code-off"

                                                   type="text"
                                                   id="recoveryCode_form"
                                                   value={recoveryCode}
                                                   onChange={(e) => setRecoveryCode(e.target.value)}
                                                   className="form-control form-control-solid"/>
                                        </div>

                                        <div className="fv-row mb-8">
                                            <input type="password" placeholder={t("auth.password")} name="password"

                                                   id="password"
                                                   value={password}
                                                   onChange={(e) => setPassword(e.target.value)}

                                                   autoComplete="new-password"
                                                   className="form-control form-control-solid"/>
                                        </div>

                                    </>
                                )}
                                <div className="d-grid mb-10">
                                    <button type="submit" id="kt_sign_in_submit" className="btn btn-primary"
                                            disabled={isLoading}>

                                        {isLoading ?
                                            (
                                                <span className="indicator-label">{t("auth.sending")}
                                                    <span
                                                        className="spinner-border spinner-border-sm align-middle ms-2">

                                                    </span>
                                                </span>
                                            ) : (
                                                !step2 ? (
                                                    <span
                                                        className="indicator-label">{t("auth.sendRecoveryCode")}</span>
                                                ) : (
                                                    <span
                                                        className="indicator-label">{t("auth.createNewPassword")}</span>
                                                )
                                            )
                                        }

                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ChangePassword;